import React, { createContext, useContext, useEffect, useState } from "react";

const UserTokenContext = createContext();

export const UserTokenProvider = ({ children }) => {
  const [userToken, setUserToken] = useState("");
  const [userName, setUserName] = useState("");
  const [userLang, setUserLang] = useState("US");
  const [menuAPI, setMenuAPI] = useState("");
  const [accounts, setAccounts] = useState("");
  const [account, setAccount] = useState("");
  const [userID, setUserID] = useState("");
  const [callerID, setCallerID] = useState("");
  const [userKvkk, setUserKvkk] = useState("-1");
  const [userPerm, setUserPerm] = useState("");
  const [customCode, setCustomCode] = useState([]);
  const [webPhone, setWebPhone] = useState("");
  const [phoneType, setPhoneType] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [board, setBoard] = useState("");
  const [menu, setMenu] = useState([]);
  const [languageData, setLanguageData] = useState({});
  const [didNo, setDidNo] = useState("");
  const [userSmsPerm, setUserSmsPerm] = useState("");
  const [userWhatsappPerm, setUserWhatsappPerm] = useState("");
  const [userTelegramPerm, setUserTelegramPerm] = useState("");
  const [userVirtualPos, setUserVirtualPos] = useState("");
  const [adminId, setAdminId] = useState("");
  const [whatsappType, setWhatsappType] = useState("");
  const [telegramType, setTelegramType] = useState("");
  const [qrID, setQRID] = useState("");
  const [qrStatus, setQrStatus] = useState("0");
  const [notifications, setNotifications] = useState([]);
  const [cantSeeDIDPerm, setCantSeeDIDPerm] = useState("");
  const [isBreak, setIsBreak] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [selectedBreak, setSelectedBreak] = useState(null);
  
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (account) {
      setWhatsappType(account?.acc_whatsapp_type);
      setTelegramType(account?.acc_telegram_type);
      setNotifications([])
    }
  }, [account])

  // console.log("callerID --> ", callerID);

  const flattenMenu = (menuArray) => {
    const result = [];

    function flatten(item) {
      const { altmenu, subsubmenu, subsubsubmenu, ...rest } = item;
      result.push(rest);

      if (altmenu) {
        altmenu.forEach(flatten);
      }

      if (subsubmenu) {
        subsubmenu.forEach(flatten);
      }

      if (subsubsubmenu) {
        subsubsubmenu.forEach(flatten);
      }
    }

    menuArray.forEach(flatten);
    return result;
  };

  const menuPermissionData = flattenMenu(menu);

  const value = {
    userToken,
    setUserToken,
    userName,
    setUserName,
    userLang,
    setUserLang,
    menuAPI,
    setMenuAPI,
    accounts,
    setAccounts,
    account,
    setAccount,
    userID,
    setUserID,
    callerID,
    setCallerID,
    customCode,
    setCustomCode,
    webPhone,
    setWebPhone,
    phoneType,
    setPhoneType,
    email,
    setEmail,
    menu,
    setMenu,
    menuPermissionData,
    userKvkk,
    setUserKvkk,
    languageData,
    setLanguageData,
    userPerm,
    setUserPerm,
    board,
    setBoard,
    didNo,
    setDidNo,
    userSmsPerm,
    setUserSmsPerm,
    userVirtualPos,
    setUserVirtualPos,
    adminId,
    setAdminId,
    whatsappType,
    setWhatsappType,
    qrID,
    setQRID,
    qrStatus,
    setQrStatus,
    userWhatsappPerm,
    setUserWhatsappPerm,
    notifications,
    setNotifications,
    cantSeeDIDPerm,
    setCantSeeDIDPerm,
    password,
    setPassword,
    isBreak,
    setIsBreak,
    userTelegramPerm,
    setUserTelegramPerm,
    telegramType,
    userPassword,
    setUserPassword,
    selectedBreak,
    setSelectedBreak,
    isMuted,
    setIsMuted,
  };

  return (
    <UserTokenContext.Provider value={value}>
      {children}
    </UserTokenContext.Provider>
  );
};

export const useUserToken = () => useContext(UserTokenContext);
